<template>
  <div class="nanhangOrderList">
    <van-form class="searchForm">
      <van-field
        v-model="form.orderNo"
        label="订单编号"
        placeholder="请输入订单编号"
        clearable
      />
      <van-field
        readonly
        clickable
        right-icon="clear"
        v-model="form.orderStartTime"
        label="订单开始时间"
        placeholder="请选择订单开始时间"
        @click="openStartTimePicker"
        @click-right-icon.stop="clearOrderStartTime"
      />
      <van-popup v-model="showStartTimePicker" position="bottom">
        <van-datetime-picker
          v-model="startPickerValue"
          type="datetime"
          title="选择开始时间"
          :min-date="minOrderDate"
          @confirm="onConfirmOrderStartTime"
          @cancel="showStartTimePicker = false"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        right-icon="clear"
        v-model="form.orderEndTime"
        label="订单结束时间"
        placeholder="请选择订单结束时间"
        @click="openEndTimePicker"
        @click-right-icon.stop="clearOrderEndTime"
      />
      <van-popup v-model="showEndTimePicker" position="bottom">
        <van-datetime-picker
          v-model="endPickerValue"
          type="datetime"
          title="选择结束时间"
          :min-date="minOrderDate"
          @confirm="onConfirmOrderEndTime"
          @cancel="showEndTimePicker = false"
        />
      </van-popup>
      <div class="formBtn">
        <van-button round block type="info" size="small" @click="handleSearch">
          查询
        </van-button>
      </div>
    </van-form>
    <van-list
      class="container"
      :loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadData"
    >
      <div
        class="group"
        v-for="(item, index) in orderList"
        :key="index + '-' + item.id + '-' + item.orderNo"
      >
        <div class="title">{{ item.goodsName || '—' }}</div>
        <div class="center">
          <div class="item">
            <div class="label">订单编号:</div>
            <div class="value">{{ item.orderNo }}</div>
          </div>
          <div class="item">
            <div class="label">订单时间:</div>
            <div class="value">{{ item.orderTime }}</div>
          </div>
          <div class="item">
            <div class="label">订单状态:</div>
            <div class="value">{{ getOrderStatusText(item.orderStatus) }}</div>
            <van-button
              v-if="
                item.orderStatus === 1 &&
                  !(item.goodsId || '').startsWith('NFHKDBK') &&
                  !(item.goodsId || '').startsWith('G3000')
              "
              size="small"
              round
              type="info"
              :loading="resendingId === item.id"
              loading-text="重发中..."
              @click="handleResend(item)"
            >
              重发短信
            </van-button>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import moment from 'moment'
import { nanhangOrderPage, nanhangResendMessage } from '@/api/nanhang'
// 订单状态展示（前端整合）：
// 后端原始状态：0待发货 1已发货 2发货失败 3出库中 4发货中 5已关闭
// 前端整合展示：1成功，2/5失败，0/3/4发货中
const ORDER_STATUS_TEXT = {
  0: '发货中',
  1: '成功',
  2: '失败',
  3: '发货中',
  4: '发货中',
  5: '失败'
}
export default {
  data() {
    return {
      loading: false,
      finished: false,
      pageNum: 0,
      pageSize: 10,
      orderList: [],
      resendingId: null,
      form: {
        orderNo: '',
        orderStartTime: '',
        orderEndTime: ''
      },
      showStartTimePicker: false,
      showEndTimePicker: false,
      startPickerValue: new Date(),
      endPickerValue: new Date(),
      minOrderDate: new Date(2023, 0, 1)
    }
  },
  created() {
    if (!sessionStorage.getItem('nanhangToken')) {
      this.$router.replace('/nanhang/login')
    }
  },
  methods: {
    async loadData(init) {
      try {
        if (init) {
          this.orderList = []
          this.pageNum = 1
          this.finished = false
        } else {
          this.pageNum++
        }
        this.loading = true
        const { data } = await nanhangOrderPage({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          param: {
            orderNo: this.form.orderNo || undefined,
            startTime: this.form.orderStartTime || undefined,
            endTime: this.form.orderEndTime || undefined
          }
        })
        // 非标套餐仅展示主订单信息，过滤附属商品
        const records = (data.records || []).filter(
          item => item.mealOrderType !== 2
        )
        this.orderList.push(...records)
        if (data.records.length < this.pageSize) {
          this.finished = true
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        this.finished = true
        console.log(error)
      }
    },
    getOrderStatusText(status) {
      return ORDER_STATUS_TEXT[status] || '—'
    },
    async handleResend(item) {
      try {
        this.resendingId = item.id
        await nanhangResendMessage(item.id)
        this.$toast.success('重发成功')
      } catch (error) {
        console.log(error)
      } finally {
        this.resendingId = null
      }
    },
    handleSearch() {
      this.loadData(1)
    },
    openStartTimePicker() {
      this.startPickerValue = this.form.orderStartTime
        ? moment(this.form.orderStartTime, 'YYYY-MM-DD HH:mm:ss').toDate()
        : new Date()
      this.showStartTimePicker = true
    },
    openEndTimePicker() {
      this.endPickerValue = this.form.orderEndTime
        ? moment(this.form.orderEndTime, 'YYYY-MM-DD HH:mm:ss').toDate()
        : new Date()
      this.showEndTimePicker = true
    },
    onConfirmOrderStartTime(value) {
      this.form.orderStartTime = moment(value).format('YYYY-MM-DD HH:mm:00')
      this.showStartTimePicker = false
    },
    onConfirmOrderEndTime(value) {
      this.form.orderEndTime = moment(value).format('YYYY-MM-DD HH:mm:59')
      this.showEndTimePicker = false
    },
    clearOrderStartTime() {
      this.form.orderStartTime = ''
    },
    clearOrderEndTime() {
      this.form.orderEndTime = ''
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background: #ecedf0;
  padding: 220px 15px 32px;
  box-sizing: border-box;
  .group {
    margin: 0 0 12px;
    position: relative;
    background: #fff;
    border-radius: 15px;
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #000000;
      line-height: 50px;
      text-align: center;
      border-bottom: dashed 1px #eaeaea;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 10px;
      box-sizing: border-box;
    }
    .center {
      padding-top: 16px;
      box-sizing: border-box;
      .item {
        display: flex;
        align-items: center;
        padding: 0 20px 16px;
        font-size: 12px;
        width: 100%;
        box-sizing: border-box;
        .label {
          color: #000000;
          width: 72px;
        }
        .value {
          flex: 1;
          width: 100%;
          color: #666666;
          word-break: break-all;
        }
      }
    }
  }
}
.searchForm {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: #fff;
  z-index: 99;
  border-radius: 15px;
  box-shadow: 0 4px 11px 0 rgba(178, 178, 178, 0.18);
}
.formBtn {
  display: flex;
  justify-content: center;
  width: 50%;
  margin: 20px auto;
}
</style>
